/* Una casella di spunta che porta scritto cosa cambia.
 *
 * **Il titolo e la spiegazione sono due cose separate**, e non e' un dettaglio
 * di stile. Mettendo la spiegazione dentro l'etichetta, il nome che uno
 * screen reader annuncia diventa "e' sostituto d'imposta se si' sulla parcella
 * compare la ritenuta d'acconto del venti per cento sul compenso privati e
 * condomini di norma no imprese e enti si'", tutto di seguito e senza pause.
 * Qui l'etichetta e' il solo titolo e la spiegazione arriva come descrizione,
 * che si annuncia dopo.
 *
 * La spiegazione c'e' su quasi tutti perche' il nome tecnico da solo non dice
 * niente a chi non lo sa gia': "sostituto d'imposta" e' quello che fa comparire
 * la ritenuta sulla parcella, e chi compila l'anagrafica deve poterlo sapere
 * senza chiederlo a qualcun altro.
 */

import { useId, type ReactNode } from "react";

interface Props {
  titolo: string;
  spiegazione?: ReactNode;
  acceso: boolean;
  cambia: (acceso: boolean) => void;
  corto?: boolean;
}

export function Interruttore({ titolo, spiegazione, acceso, cambia, corto }: Props) {
  const id = useId();
  const idAiuto = `${id}-aiuto`;

  return (
    <div className={corto ? "interruttore interruttore-corto" : "interruttore"}>
      <input
        id={id}
        type="checkbox"
        checked={acceso}
        aria-describedby={spiegazione === undefined ? undefined : idAiuto}
        onChange={(e) => cambia(e.target.checked)}
      />
      <div>
        <label htmlFor={id}>{titolo}</label>
        {spiegazione !== undefined && (
          <p className="aiuto" id={idAiuto}>
            {spiegazione}
          </p>
        )}
      </div>
    </div>
  );
}
